/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface SemanticDomainFull
 */
export interface SemanticDomainFull {
  /**
   *
   * @type {string}
   * @memberof SemanticDomainFull
   */
  mongoId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainFull
   */
  guid: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainFull
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainFull
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainFull
   */
  lang: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainFull
   */
  userId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainFull
   */
  created?: string | null;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainFull
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainFull
   */
  parentId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SemanticDomainFull
   */
  questions: Array<string>;
}
